import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { CountryCurrencyServices } from '../services/countryCurrencyServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class CountryCurrencyStore {    

    
  rootStore;
    countryCurrencies = [];
    countryCurrency = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          countryCurrencies: observable,
          countryCurrency: observable,
          getAll: action,          
          reset: action,
          save: action,
          remove: action,            
      });
      makePersistable(this, { name: 'countryCurrencyStore', properties: ['config'], storage: window.localStorage });

    }          

    remove = async (id) => {
        try {
            const data = await CountryCurrencyServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("countryCurrency") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await CountryCurrencyServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("countryCurrency") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await CountryCurrencyServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("countryCurrency") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.countryCurrency = {});
    }
    
    
    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await CountryCurrencyServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.countryCurrencies = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.countryCurrencies = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await CountryCurrencyServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.countryCurrencies = data;})
        }
        catch (error) {
            runInAction(() => { this.countryCurrencies = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await CountryCurrencyServices.getById(id);
            runInAction(() => { this.countryCurrency = data;});
        } catch (error) {
            runInAction(() => { this.countryCurrency = {};})
        }
    };

    
}